<template>
  <div id="app">
    <navbar :info="data.info" :items="data.items"></navbar>
    <router-view :info="data.info"/>
    <end-footer :info="data.info" :items="data.items"></end-footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      data: {
        info: {
          phone: '+351 927 552 162',
          address: {
            street: 'IPN incubator, Bloco C ',
            city: 'Coimbra - PT',
            complement: '',
            lat: '',
            long: '',
            mapUrl: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12191.037709768274!2d-8.414164!3d40.192167!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x62667da29126b7a5!2sINSTITUTO%20PEDRO%20NUNES!5e0!3m2!1spt-BR!2sbr!4v1572978809819!5m2!1spt-BR!2sbr'

            
          },
          //facebook_link: 'https://www.facebook.com/viitrainovacoes/',
          //instagram_link: 'https://www.instagram.com/viitrainovacoes/',
          linkedin_link: 'https://pt.linkedin.com/company/alphabet-sphere-lda',
          email: 'luis@alphabetsphere.com',
        },
        items: [
          { label: 'Home', link: '/home'},
          { label: 'About Us ', link: '/sobre'},
          { label: 'Solutions', link: '/solucoes'},
          // { label: 'Blog', link: '/blog'},
          { label: 'Contact', link: '/contato'},
        ]
      }
    }
  }
};
</script>

<style lang="scss">
  @import 'assets/stylesheets/scss/main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue